import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  acceptInvite,
  forgotPassword,
  IAcceptInput,
  IForgotPasswordInput,
  ILoginInput, IRefreshTokenInput,
  login,
  refreshToken,
} from "@/auth/api/requests/auth.requests.ts";

export const useForgotPassword = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: IForgotPasswordInput) => forgotPassword(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries();
    },
  });
};




export const useLogin = () => {

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ILoginInput) => login(data),
    onSuccess: async () => {
      console.log("Successfully authenticated");
    }
  })
}

export const useAcceptInvite = () => {

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IAcceptInput) => acceptInvite(data),
    onSuccess: async () => {
      console.log("Successfully accepted");
    }
  })
}


export const useRefreshToken = () => {

  return useMutation({
    mutationFn: (data: IRefreshTokenInput) => refreshToken(data),
    onSuccess: async () => {
      console.log("Successfully authenticated");
    }
  })
}


